module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"g":"Date de début","h":"Date de fin","i":"Entreprise","j":"Titre","k":"Description :","l":"Description","m":"Environnement technique"},"en":{"g":"Start date","h":"End date","i":"Company","j":"Title","k":"Description :","l":"Description","m":"Technical environment"}}')
  delete Component.options._Ctor
}
